import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase/config";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import "./PlansScreen.css";

const PlansScreen = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [hasUsedTrial, setHasUsedTrial] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          const userSnap = await getDoc(doc(db, "usuarios", currentUser.uid));
          if (userSnap.exists()) {
            const data = userSnap.data();
            const planName = (data.planEntrenamiento || data.plan || data.selectedPlan || "").toLowerCase();
            const trialDone = Boolean(
              data.haUsadoTrial ||
              data.trialUtilizado ||
              planName.includes("trial") ||
              planName.includes("7") ||
              planName.includes("seman")
            );
            setHasUsedTrial(trialDone);
          }
        } catch {
          setHasUsedTrial(false);
        }
      } else {
        setUser(null);
        setHasUsedTrial(false);
      }
      setLoading(false);
    });

    return () => unsub();
  }, []);

  const handleSelectPlan = (plan) => {
    localStorage.setItem("selectedPlan", JSON.stringify(plan));

    if (user && !plan.isLaunchTrial) {
      navigate("/pago-transferencia");
    } else {
      navigate("/register");
    }
  };

  return (
    <div className="plans-container">
      <h1>Elige tu plan</h1>
      <p className="subtitle">Comienza tu transformación hoy</p>

      <div style={styles.launchCard}>
        <span style={styles.badgePromo}>Acceso Exclusivo</span>
        <h2 style={styles.launchTitle}>¿Te registraste en el prelanzamiento?</h2>
        <p style={styles.launchSubtitle}>
          Canjea aquí tus 7 días de acceso completo sin costo ingresando con el correo de tu reserva.
        </p>
        <button
          disabled={hasUsedTrial || loading}
          onClick={() =>
            handleSelectPlan({
              id: "trial_lanzamiento",
              name: "Semana Gratis (Lanzamiento)",
              price: 0,
              duration: "7d",
              isLaunchTrial: true,
            })
          }
          style={{
            ...styles.launchBtn,
            opacity: hasUsedTrial ? 0.6 : 1,
            cursor: hasUsedTrial ? "not-allowed" : "pointer",
          }}
        >
          {hasUsedTrial ? "Beneficio ya utilizado" : "Canjear mis 7 días gratis"}
        </button>
      </div>

      <div className="plans-grid">
        <div className={`plan-card ${hasUsedTrial ? "disabled" : ""}`}>
          <span className="badge trial-badge">Prueba</span>
          <h2>Plan 7 días</h2>
          <p className="available-now" style={{ color: "#b03060", fontWeight: 600 }}>
            * Válido 1 vez por usuario
          </p>

          <div className="price-container">
            <h3 className={hasUsedTrial ? "disabled-price" : ""}>$4.990</h3>
            <p>/ 7 días</p>
          </div>

          <ul>
            <li>✔ Acceso completo por 7 días</li>
            <li>✔ Rutinas personalizadas</li>
            <li>✔ Seguimiento de progreso</li>
            <li style={{ fontStyle: "italic", color: "#64748b" }}>
              Válido solo primera contratación
            </li>
          </ul>

          <button
            disabled={hasUsedTrial || loading}
            onClick={() =>
              handleSelectPlan({
                id: "trial",
                name: "7 días",
                price: 4990,
                duration: "7d",
                isLaunchTrial: false,
              })
            }
            style={hasUsedTrial ? { cursor: "not-allowed", opacity: 0.6 } : {}}
          >
            {hasUsedTrial ? "Ya utilizado" : "Elegir plan"}
          </button>
        </div>

        <div className="plan-card featured">
          <span className="badge popular-badge">20% OFF Lanzamiento</span>
          <h2>Plan Mensual</h2>
          <p className="available-now">Disponible ahora</p>

          <div className="price-container">
            <span className="original-price">$37.490</span>
            <h3 className="promo-price">$29.990</h3>
            <p>/ mes</p>
          </div>

          <ul>
            <li>✔ Acceso completo</li>
            <li>✔ Rutinas personalizadas</li>
            <li>✔ Seguimiento de progreso</li>
          </ul>

          <button
            disabled={loading}
            onClick={() =>
              handleSelectPlan({
                id: "monthly",
                name: "Mensual",
                price: 29990,
                duration: "1m",
                isLaunchTrial: false,
              })
            }
          >
            Elegir plan
          </button>
        </div>

        <div className="plan-card disabled">
          <span className="badge disabled-badge">Próximamente</span>
          <h2>Plan Semestral</h2>
          <div className="price-container">
            <h3 className="disabled-price">$139.990</h3>
            <p>/ 6 meses</p>
          </div>
          <ul>
            <li>✔ Todo lo anterior</li>
            <li>✔ Ahorra $39.950</li>
          </ul>
          <button disabled>No disponible</button>
        </div>

        <div className="plan-card disabled">
          <span className="badge disabled-badge">Próximamente</span>
          <h2>Plan Anual</h2>
          <div className="price-container">
            <h3 className="disabled-price">$199.990</h3>
            <p>/ año</p>
          </div>
          <ul>
            <li>✔ Todo lo anterior</li>
            <li>✔ Ahorra $159.890</li>
          </ul>
          <button disabled>No disponible</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  launchCard: {
    background: "linear-gradient(135deg, #ffffff 0%, #fdf2f8 100%)",
    border: "1.5px solid #fbcfe8",
    borderRadius: 20,
    padding: "24px 20px",
    maxWidth: 820,
    margin: "0 auto 36px auto",
    textAlign: "center",
    boxShadow: "0 8px 24px rgba(176, 48, 96, 0.08)",
  },
  badgePromo: {
    display: "inline-block",
    background: "#b03060",
    color: "#ffffff",
    padding: "4px 12px",
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 0.5,
    textTransform: "uppercase",
    marginBottom: 10,
  },
  launchTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#1e293b",
    margin: "0 0 6px 0",
  },
  launchSubtitle: {
    fontSize: 13.5,
    color: "#475569",
    maxWidth: 580,
    margin: "0 auto 16px auto",
    lineHeight: 1.5,
  },
  launchBtn: {
    backgroundColor: "#b03060",
    color: "#ffffff",
    border: "none",
    padding: "11px 26px",
    borderRadius: 50,
    fontWeight: 600,
    fontSize: 13.5,
    boxShadow: "0 4px 12px rgba(176, 48, 96, 0.22)",
    transition: "background 0.2s ease",
  },
};

export default PlansScreen;